import { __assign } from "tslib";
import { classNamesFunction, Stack } from '@fluentui/react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import React from 'react';
import { KeyCode } from '../../utils';
import { NotificationItemDisplayStatus, NotificationItemStatus } from './CoherenceNotificationItem.types';
import { DismissedNotification } from './DismissedNotification/DismissedNotification';
import { NotificationAction } from './NotificationAction/NotificationAction';
import { NotificationBody } from './NotificationBody/NotificationBody';
import { NotificationHeader } from './NotificationHeader/NotificationHeader';
import { NotificationIcon } from './NotificationIcon/NotificationIcon';
dayjs.extend(duration);
dayjs.extend(localizedFormat);
var getClassNames = classNamesFunction();
var convertOldSenderData = function (senderName, senderImageUrl) {
    return { name: senderName, imageUrl: senderImageUrl };
};
var convertOldSubjectData = function (subjectHeader, subjectIcon, subjectIconColor) {
    return { header: subjectHeader !== null && subjectHeader !== void 0 ? subjectHeader : '', icon: subjectIcon, iconColor: subjectIconColor };
};
export var CoherenceNotificationItemBase = function (props) {
    var _a, _b;
    var styles = props.styles, theme = props.theme, item = props.item, _c = props.isToast, isToast = _c === void 0 ? false : _c, openItem = props.openItem, onSetCurrentNotificationItem = props.onSetCurrentNotificationItem;
    var classNames = getClassNames(styles, {
        theme: theme,
        isRead: item.status === NotificationItemStatus.READ
    });
    var sender = (_a = item.sender) !== null && _a !== void 0 ? _a : convertOldSenderData(item.senderName, item.senderImageUrl);
    var subject = (_b = item.subject) !== null && _b !== void 0 ? _b : convertOldSubjectData(item.subjectHeader, item.subjectIcon, item.subjectIconColor);
    var openNotificationItem = function () {
        var _a;
        onSetCurrentNotificationItem === null || onSetCurrentNotificationItem === void 0 ? void 0 : onSetCurrentNotificationItem(item);
        (_a = props.updateItem) === null || _a === void 0 ? void 0 : _a.call(props, item.itemKey, NotificationItemDisplayStatus.OLD, NotificationItemStatus.READ);
        openItem === null || openItem === void 0 ? void 0 : openItem(item.itemKey);
    };
    if (item.displayStatus === NotificationItemDisplayStatus.DISMISS) {
        var dismissedNotificationProps = {
            notificationDismissedMessage: props.notificationDismissedMessage,
            itemActionsText: props.itemActionsText,
            updateNotificationItem: props.updateItem,
            itemKey: item.itemKey
        };
        return React.createElement(DismissedNotification, __assign({}, dismissedNotificationProps));
    }
    var statusId = "coher-notificationItem-status-id-" + item.itemKey;
    var senderId = "coher-notificationItem-senderName-id-" + item.itemKey;
    var subjectId = "coher-notificationItem-subject-id-" + item.itemKey;
    var buttonId = "coher-notificationItem-buttonDiv-id-" + item.itemKey;
    var standardId = "coher-notificationItem-standardDiv-id-" + item.itemKey;
    var isNotificationClickable = !isToast && openItem !== undefined;
    return (React.createElement("div", { className: classNames.root, role: "presentation" },
        React.createElement("div", { id: isNotificationClickable ? buttonId : standardId, className: classNames.rootButtonDiv, tabIndex: isNotificationClickable ? 0 : -1, "aria-labelledby": statusId + " " + senderId + " " + subjectId, onClick: isNotificationClickable ? function () { return openNotificationItem(); } : undefined, onKeyPress: isNotificationClickable
                ? function (event) {
                    var code = event.keyCode || event.which;
                    if (code === KeyCode.Enter || code === KeyCode.Space) {
                        openNotificationItem();
                    }
                }
                : undefined, role: isNotificationClickable ? 'button' : undefined },
            React.createElement("div", { className: classNames.buttonContent },
                React.createElement(Stack, { horizontal: true },
                    React.createElement(NotificationIcon, { sender: sender, subject: subject, notificationType: props.type }),
                    React.createElement(Stack, { style: { width: '100%' } },
                        React.createElement(NotificationHeader, { item: item, subject: subject, subjectId: subjectId, sender: sender, senderId: senderId, timeGroupLabels: props.timeGroupLabels, timeFormatter: props.timeFormatter, dateFormatter: props.dateFormatter }),
                        React.createElement(NotificationAction, { isToast: isToast, itemKey: item.itemKey, itemStatus: item.status, onDismiss: props.onDismiss, updateNotificationItem: props.updateItem, itemActionsText: props.itemActionsText }),
                        React.createElement(NotificationBody, { itemActionsText: props.itemActionsText, isToast: isToast, item: item, sender: sender, subject: subject, showNotificationList: function () {
                                var _a;
                                onSetCurrentNotificationItem === null || onSetCurrentNotificationItem === void 0 ? void 0 : onSetCurrentNotificationItem(item);
                                (_a = props.showNotificationList) === null || _a === void 0 ? void 0 : _a.call(props);
                            } })))))));
};
//# sourceMappingURL=CoherenceNotificationItem.base.js.map